import React from 'react'
import PropTypes from 'prop-types'
import I18n from '../../../resources/i18n/I18n'
import './TransferButtons.scss'

const TransferButtons = ({ onTransferRight, onTransferLeft, rightDisabled, leftDisabled }) => {
  return (
    <div className="d-flex flex-column justify-content-center h-100 transfer-buttons">
      <div
        onClick={!rightDisabled ? onTransferRight : undefined}
        className={`transfer-button mb-2 ${rightDisabled ? 'disabled' : ''}`}
        title={I18n.t('TransferToAssociated')}
      >
        <i className="fa fa-chevron-right rct-icon rct-icon-expand-close" />
      </div>
      <div
        onClick={!leftDisabled ? onTransferLeft : undefined}
        className={`transfer-button ${leftDisabled ? 'disabled' : ''}`}
        title={I18n.t('TransferToAvailable')}
      >
        <i className="fa fa-chevron-left rct-icon rct-icon-expand-close" />
      </div>
    </div>
  )
}

TransferButtons.propTypes = {
  onTransferRight: PropTypes.func.isRequired,
  onTransferLeft: PropTypes.func.isRequired,
  rightDisabled: PropTypes.bool,
  leftDisabled: PropTypes.bool,
}

TransferButtons.defaultProps = {
  rightDisabled: false,
  leftDisabled: false,
}

export default TransferButtons
